module.exports = __webpack_public_path__ + "static/media/link-icon-light.f4b3ccf4.svg";